import userIcons from '../../assets/icons/user';

const getRandomUserIcon = (): string => {
  const iconKeys = Object.keys(userIcons);

  return userIcons[iconKeys[(iconKeys.length * Math.random()) << 0]];
};

export default getRandomUserIcon;
